import { usePerms } from 'contexts/PermsContext';
import AlertCreator from 'features/Weather/features/WeatherAlerts/features/AlertCreator/index.web';
import WeatherAlertsWidget from 'features/Weather/features/WeatherAlerts/index.web.widget';

const CreateAlert = ({ widget, dimensions }) => {
  const perms = usePerms();
  const canCreateAlert =
    perms.testPermission([8, 9, 10, 11, 12, 13], ['Create-EditAlerts']) ||
    perms.testPermission([8, 9, 10, 11, 12, 13], ['CreateFemaAlert']);

  if (dimensions?.length && canCreateAlert) {
    return <WeatherAlertsWidget dimensions={dimensions} widget={widget} widgetType="create" />;
  }

  if (canCreateAlert) {
    return <AlertCreator perms={perms} />;
  }
};

export default CreateAlert;
